import React, { useEffect, useRef, useState } from "react";
import { Controller, Scene } from "react-scrollmagic";
import { Tween, Timeline } from "react-gsap";

// import data from "./data";
import Figure from "./figure";

import "./style.scss";
import { useMediaQuery } from "beautiful-react-hooks";

const ScrollSlider = ({ data, parentCategory, blockMode }) => {
  const mediaDesktop = useMediaQuery("(min-width: 1025px)");
  const mediaTablet = useMediaQuery(
    "(min-width: 769px) and (max-width: 1024px)"
  );
  const mediaMobile = useMediaQuery(
    "(min-width: 320px) and (max-width: 768px)"
  );

  return (
    <Controller>
      <Scene triggerHook="onLeave" duration={6000} pin>
        {(progress, other) => (
          <section className="site-block site-block__scroll">
            <div className="scrollable-list__wrap">
              <div className="scrollable-list__scroller">
                <Timeline totalProgress={progress} paused>
                  <Tween
                    className="scrollable-list trendy-list"
                    from={{ x: "0px" }}
                    to={{
                      x: `-${
                        (data.length - 1) *
                        (mediaDesktop ? 580 : mediaTablet ? 450 : 410)
                      }px`,
                    }}
                  >
                    <ul
                      class="scrollable-list trendy-list"
                      style={{
                        width: `${
                          data.length *
                          (mediaDesktop ? 550 : mediaTablet ? 430 : 330)
                        }%`,
                        height: "574px",
                      }}
                    >
                      <li className="trendy-list__item trendy-list__item--empty"></li>

                      {data.map((article) => (
                        <Figure
                          {...article}
                          parentCategory={parentCategory}
                          blockMode={blockMode}
                        />
                      ))}
                    </ul>
                  </Tween>
                </Timeline>
              </div>
            </div>
          </section>
        )}
      </Scene>
    </Controller>
  );
};

export default ScrollSlider;
